import TeamSelector from "../components/TeamSelector";
import { useNavigate } from "react-router-dom";
import { generateDirectTeamFixture } from "../utils/scenarioEngine";
import { Team } from "../types/team";

export default function HomePage() {
  const navigate = useNavigate();

  const handleTeamSelect = (team: Team) => {
    const result = generateDirectTeamFixture(team);
    navigate("/fixture", { state: result });
  };

  return (
    <div className="p-8 min-h-screen">
      <h1 className="text-4xl font-bold mb-2 text-center text-white drop-shadow-lg font-sporty">
        🏆 Şampiyonlar Ligi Fikstür Simülasyonu
      </h1>
      <p className="text-center text-gray-200 mb-10 text-lg">
        Aşağıdan bir takım seçin, fikstürü görmeye başlayın!
      </p>
      <TeamSelector onTeamSelect={handleTeamSelect} />
    </div>
  );
}
